import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDocumentSignersTableColumns } from './hooks/use_document_signers_table_columns.hook';
const TABLE_BORDER = '#E5E7EB';
const WRAPPER_STYLE = {
    overflow: 'hidden',
    background: '#FFFFFF',
    border: `1px solid ${TABLE_BORDER}`,
    borderRadius: 8,
};
const TABLE_STYLE = {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
};
const HEADER_CELL_STYLE = {
    padding: '10px 20px',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    color: '#6B7280',
    textAlign: 'left',
    verticalAlign: 'middle',
    background: '#F9FAFB',
    borderBottom: `1px solid ${TABLE_BORDER}`,
};
const BODY_CELL_STYLE = {
    padding: '10px 20px',
    fontSize: 13.5,
    lineHeight: '19px',
    fontWeight: 400,
    color: '#374151',
    textAlign: 'left',
    verticalAlign: 'middle',
};
const ORDER_CELL_STYLE = {
    ...BODY_CELL_STYLE,
    width: 110,
    fontWeight: 500,
    color: '#4F46E5',
};
const COLUMN_WIDTHS = {
    order: 110,
    signerRole: 280,
    status: 240,
    actions: 48,
};
const columnKey = (column, index) => {
    if (column.id) {
        return column.id;
    }
    if ('accessorKey' in column && column.accessorKey) {
        return String(column.accessorKey);
    }
    return `column-${index}`;
};
export const DocumentSignersTable = ({ rows = [], showRowActions = false, onOpenSignerInvite, canSignNowFor, onSignNow, emptyLabel, }) => {
    const { signersColumns } = useDocumentSignersTableColumns({
        rows,
        showRowActions,
        onOpenSignerInvite,
        canSignNowFor,
        onSignNow,
    });
    return (_jsx("div", { "data-testid": 'document-signers-table', style: WRAPPER_STYLE, children: _jsxs("table", { style: TABLE_STYLE, children: [_jsx("thead", { children: _jsx("tr", { children: signersColumns.map((column, index) => {
                            const key = columnKey(column, index);
                            const width = COLUMN_WIDTHS[key];
                            return (_jsx("th", { style: width ? { ...HEADER_CELL_STYLE, width } : HEADER_CELL_STYLE, children: typeof column.header === 'string' ? column.header : null }, key));
                        }) }) }), _jsx("tbody", { children: rows.length === 0 ? (_jsx("tr", { children: _jsx("td", { colSpan: signersColumns.length, style: BODY_CELL_STYLE, children: emptyLabel }) })) : (rows.map((row, rowIndex) => {
                        const isLastRow = rowIndex === rows.length - 1;
                        const rowBorder = isLastRow ? {} : { borderBottom: `1px solid ${TABLE_BORDER}` };
                        return (_jsx("tr", { "data-testid": 'signer-row', style: rowBorder, children: signersColumns.map((column, index) => {
                                const key = columnKey(column, index);
                                const isOrder = key === 'order';
                                const cellStyle = {
                                    ...(isOrder ? ORDER_CELL_STYLE : BODY_CELL_STYLE),
                                    ...rowBorder,
                                };
                                return (_jsx("td", { style: cellStyle, children: column.cell?.({
                                        row: { original: row },
                                    }) ?? null }, key));
                            }) }, row.id));
                    })) })] }) }));
};
